var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 14.4C9.69748 14.4 11.3253 13.7257 12.5256 12.5255C13.7258 11.3253 14.4001 9.69739 14.4001 8.00001C14.4001 6.30262 13.7258 4.67476 12.5256 3.47452C11.3253 2.27429 9.69748 1.60001 8.0001 1.60001C6.30271 1.60001 4.67485 2.27429 3.47461 3.47452C2.27438 4.67476 1.6001 6.30262 1.6001 8.00001C1.6001 9.69739 2.27438 11.3253 3.47461 12.5255C4.67485 13.7257 6.30271 14.4 8.0001 14.4ZM10.9657 7.43441L8.5657 5.03441C8.41568 4.88443 8.21223 4.80018 8.0001 4.80018C7.78797 4.80018 7.58452 4.88443 7.4345 5.03441L5.0345 7.43441C4.88877 7.58529 4.80814 7.78737 4.80996 7.99713C4.81178 8.20688 4.89592 8.40753 5.04424 8.55586C5.19257 8.70419 5.39322 8.78832 5.60298 8.79015C5.81273 8.79197 6.01482 8.71133 6.1657 8.56561L7.2001 7.53121V10.4C7.2001 10.6122 7.28438 10.8157 7.43441 10.9657C7.58444 11.1157 7.78792 11.2 8.0001 11.2C8.21227 11.2 8.41575 11.1157 8.56578 10.9657C8.71581 10.8157 8.8001 10.6122 8.8001 10.4V7.53121L9.8345 8.56561C9.98538 8.71133 10.1875 8.79197 10.3972 8.79015C10.607 8.78832 10.8076 8.70419 10.956 8.55586C11.1043 8.40753 11.1884 8.20688 11.1902 7.99713C11.1921 7.78737 11.1114 7.58529 10.9657 7.43441Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleUp);
export default __webpack_public_path__ + "static/media/ArrowCircleUp.f5d0c4f6b0543f7b0492dcb9e5d10071.svg";
export { ForwardRef as ReactComponent };